import { HotelReserveCardCancellationModalType } from "@website/accommodation-ui/hotel-reserve-rooms-layout/hotel-reserve-card/hotel-reserve-card-cancellation-modal/hotel-reserve-card-cancellation-modal.types";
import { fetcher } from "@website/fetcher/fetcher";
import { useFetcher } from "@website/fetcher/use-fetcher";
import { replaceOptions } from "@website/utils/replace-options";

export const useHotelreservecardCancellationModal = (
  properties: HotelReserveCardCancellationModalType
) => {
  const { onClose, open, bundleId } = properties;

  //TODO: move fetch to out of libs
  const { data: policies, isLoading } = useFetcher({
    queryKey: [bundleId],
    queryFn: () =>
      fetcher({
        url: replaceOptions(
          `${process.env.NEXT_PUBLIC_BASE_URL_API}/bookings/room-policies?reserveToken={bundleId}`,
          { bundleId }
        )
      }),
    enabled: open && Boolean(bundleId),
    refetchOnMount: "always"
  });

  return {
    modalProps: {
      open: open,
      onClose: onClose,
      showCloseButton: false,
      mobileHeight: "auto" as const,
      animate: "bottom" as const
    },
    title: "قوانین کنسلی",
    policies: policies?.data?.data?.policies as Array<string>,
    isLoading,
    buttonProps: {
      size: "large" as const,
      children: "متوجه شدم",
      color: "secondary" as const,
      fullWidth: true,
      onClick: onClose
    }
  };
};
